import { render, staticRenderFns } from "./IirPage.vue?vue&type=template&id=cbd26902&"
import script from "./IirPage.vue?vue&type=script&lang=js&"
export * from "./IirPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports